import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
    Container, Card, ListGroup, Badge, Spinner, Button, Alert, 
    Form, Modal, Row, Col 
} from 'react-bootstrap';
import api from '../services/api';
import ReactPlayer from 'react-player';
import { ProgressBar } from 'react-bootstrap';

const CourseDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [userRole, setUserRole] = useState(null);
    const [user, setUser] = useState(null)
    const [success, setSuccess] = useState('');
    // Stany dla modali edycji
    const [showSectionModal, setShowSectionModal] = useState(false);
    const [showLessonModal, setShowLessonModal] = useState(false);
    const [editingSection, setEditingSection] = useState(null);
    const [editingLesson, setEditingLesson] = useState(null);
    const [sectionForm, setSectionForm] = useState({ title: '', order: 1 });
    const [lessonForm, setLessonForm] = useState({ 
        title: '', content_type: 'text', content: {}, order: 1, duration_minutes: 15 
    });
    const [isEnrolled, setIsEnrolled] = useState(false);
    const [enrollmentLoading, setEnrollmentLoading] = useState(false);
    const [courseProgress, setCourseProgress] = useState({ total: 0, completed: 0, percentage: 0 });
    const [downloading, setDownloading] = useState(false);

    useEffect(() => {
        fetchCourse();
        fetchUser()
        fetchUserRole()
    }, [id]);
    useEffect(() => {
        if (user && user?.role === 'student') {
            checkEnrollment();
            fetchCourseProgress();}
    }, [user]);
    //Funkcje certyfikatu
    const handleDownloadCertificate = async () => {
        setDownloading(true);
        try {
            const response = await api.get(`/courses/${id}/download_certificate/`, {
                responseType: 'blob'
            });
            
            // Stwórz link do pobrania
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `certyfikat_${course.title}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            
        } catch (err) {
            console.error('❌ Błąd pobierania certyfikatu:', err);
            setError(err.response?.data?.error || 'Nie udało się pobrać certyfikatu');
        } finally {
            setDownloading(false);
        }
    };
    //Dla progress bar
    const fetchCourseProgress = async () => {
        try {
            const response = await api.get(`/courses/${id}/progress/`);
            setCourseProgress({
                total: response.data.total_lessons,
                completed: response.data.completed_lessons,
                percentage: response.data.percentage
            });
        } catch (err) {
            console.error('❌ Błąd pobierania postępu:', err);
        }
    };

    const fetchCourse = async () => {
        try {
            const response = await api.get(`/courses/${id}/`);
            setCourse(response.data);
        } catch (err) {
            setError('Nie udało się pobrać kursu');
        } finally {
            setLoading(false);
        }
    };

    const fetchUserRole = async () => {
        try {
            const response = await api.get('/users/me/');
            setUserRole(response.data.role);
        } catch (err) {
            console.error('Błąd pobierania roli:', err);
        }
    };
    const fetchUser = async () => {
        try {
            const response = await api.get('/users/me/');
            setUser(response.data);
        } catch (err) {
            console.error('Błąd pobierania użytkownika:', err);
        }
    };
    const isInstructor = userRole === 'instructor';
    const isStudent = userRole === 'student';
    const isOwner = course?.instructor === user?.id;

    // Funkcje dla sekcji
    const handleAddSection = async () => {
        try {
            await api.post(`/courses/${id}/sections/`, sectionForm);
            setShowSectionModal(false);
            setSectionForm({ title: '', order: 1 });
            fetchCourse();
        } catch (err) {
            console.error('Błąd dodawania sekcji:', err);
        }
    };

    const handleEditSection = async (section) => {
        try {
            await api.put(`/sections/${section.id}/`, sectionForm);
            setShowSectionModal(false);
            setEditingSection(null);
            fetchCourse();
        } catch (err) {
            console.error('Błąd edycji sekcji:', err);
        }
    };

    const handleDeleteSection = async (sectionId) => {
        if (window.confirm('Czy na pewno chcesz usunąć tę sekcję?')) {
            try {
                await api.delete(`/sections/${sectionId}/`);
                fetchCourse();
            } catch (err) {
                console.error('Błąd usuwania sekcji:', err);
            }
        }
    };

    // Funkcje dla lekcji
    const handleAddLesson = async () => {
        try {
            await api.post(`/sections/${editingSection?.id}/lessons/`, lessonForm);
            setShowLessonModal(false);
            setLessonForm({ title: '', content_type: 'text', content: {}, order: 1, duration_minutes: 15 });
            fetchCourse();
        } catch (err) {
            console.error('Błąd dodawania lekcji:', err);
        }
    };

    const handleEditLesson = async (lesson) => {
        try {
            await api.put(`/lessons/${lesson.id}/`, lessonForm);
            setShowLessonModal(false);
            setEditingLesson(null);
            fetchCourse();
        } catch (err) {
            console.error('Błąd edycji lekcji:', err);
        }
    };

    const handleDeleteLesson = async (lessonId) => {
        if (window.confirm('Czy na pewno chcesz usunąć tę lekcję?')) {
            try {
                await api.delete(`/lessons/${lessonId}/`);
                fetchCourse();
            } catch (err) {
                console.error('Błąd usuwania lekcji:', err);
            }
        }
    };

    const openSectionModal = (section = null) => {
        if (section) {
            setEditingSection(section);
            setSectionForm({ title: section.title, order: section.order });
        } else {
            setEditingSection(null);
            setSectionForm({ title: '', order: course?.sections?.length + 1 || 1 });
        }
        setShowSectionModal(true);
    };

    const openLessonModal = (section, lesson = null) => {
        setEditingSection(section);
        if (lesson) {
            setEditingLesson(lesson);
            setLessonForm({
                title: lesson.title,
                content_type: lesson.content_type,
                content: lesson.content,
                order: lesson.order,
                duration_minutes: lesson.duration_minutes
            });
        } else {
            setEditingLesson(null);
            setLessonForm({
                title: '',
                content_type: 'text',
                content: {},
                order: section.lessons?.length + 1 || 1,
                duration_minutes: 15
            });
        }
        setShowLessonModal(true);
    };
    //Sprawdzanie zeby ukryc guzik zapisz 
    const checkEnrollment = async () => {

        try {
            const response = await api.get(`/courses/${id}/enrollment_status/`);
            setIsEnrolled(response.data.is_enrolled);

        } catch (err) {
            console.error('❌ Błąd sprawdzania zapisu:', err);
        }
    };
    const getDifficultyBadge = (difficulty) => {
        const variants = { beginner: 'success', intermediate: 'warning', advanced: 'danger' };
        const labels = { beginner: 'Początkujący', intermediate: 'Średniozaawansowany', advanced: 'Zaawansowany' };
        return <Badge bg={variants[difficulty] || 'secondary'}>{labels[difficulty] || difficulty}</Badge>;
    };

    // Funkcja zapisu na kurs
    const handleEnroll = async () => {
        setEnrollmentLoading(true);
        setError(''); 
        setSuccess('');
        try {
            await api.post(`/courses/${id}/enroll/`);
            setIsEnrolled(true);
            setSuccess('✅ Zapisano na kurs pomyślnie!');
            await fetchCourse();
        } catch (err) {
            console.error('Błąd zapisu:', err);
            if (err.response?.status === 403) {
                setError('Tylko studenci mogą zapisywać się na kursy.');
            } else if (err.response?.status === 400) {
                setError('Już jesteś zapisany na ten kurs.');
            } else {
                setError('Nie udało się zapisać na kurs.');
            }
        } finally {
            setEnrollmentLoading(false);
        }
    };
    if (loading) return <Container className="text-center mt-5"><Spinner animation="border" variant="primary" /></Container>;
    if (error) return <Container className="mt-5"><Alert variant="danger">{error}</Alert></Container>;
    if (!course) return <Container className="mt-5"><Alert variant="warning">Kurs nie znaleziony</Alert></Container>;

    return (
        <Container className="mt-4 mb-5">
            {/* Header z przyciskami dla instruktora */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                    <Button 
                        variant="outline-primary" 
                        onClick={() => navigate(`/courses`)}
                        className="d-flex align-items-center gap-2">
                        ← Wróć do przeglądu kursów
                    </Button>
            <div className="d-flex align-items-center gap-2 flex-wrap">
                {isInstructor && isOwner && (
                    <div className="d-flex gap-2">
                        <Button variant="outline-primary" size="sm" onClick={() => navigate(`/courses/${id}/edit`)}>
                            ✏️ Edytuj kurs
                        </Button>
                        <Button variant="outline-danger" size="sm" onClick={() => {
                            if (window.confirm('Usunąć kurs?')) api.delete(`/courses/${id}/`).then(() => navigate('/courses'));
                        }}>🗑️ Usuń kurs</Button>

                    </div>
                )}
                {isStudent && courseProgress.percentage === 100 && (
                    <Button 
                        variant="outline-primary" 
                        onClick={handleDownloadCertificate}
                        disabled={downloading}
                        className="mt-3"
                    >
                        {downloading ? 'Generowanie...' : '🎓 Pobierz certyfikat'}
                    </Button>
                )}
                    {user?.role === 'student' && (
                        <Button 
                            variant={isEnrolled ? "success" : "primary"}
                            onClick={handleEnroll}
                            disabled={isEnrolled || enrollmentLoading}
                            className="mt-3"
                            style={{ 
                                backgroundColor: isEnrolled ? '#7bb8b8' : '#6366f1', 
                                borderColor: isEnrolled ? '#10b981' : '#6366f1' 
                            }}
                        >
                            {enrollmentLoading ? 'Zapisywanie...' : 
                            isEnrolled ? 'Zapisany' : '📝 Zapisz się na kurs'}
                        </Button>
                    )}
                    </div>
            </div>
            {/* Szczegóły kursu */}
            <Card className="mb-4 shadow-sm">
                <Card.Body>
                    <h1>{course.title}</h1>
                    <p className="text-muted">{course.description}</p>
                    {isStudent && (
                        <div className="mt-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <small className="text-muted">Twój postęp</small>
                                <small className="text-muted fw-bold">{courseProgress.percentage}%</small>
                            </div>
                            <ProgressBar 
                                now={courseProgress.percentage} 
                                variant={courseProgress.percentage === 100 ? 'success' : 'primary'}
                                style={{ height: '10px', borderRadius: '5px' }}
                            />
                            <small className="text-muted">
                                {courseProgress.completed} / {courseProgress.total} lekcji ukończonych
                            </small>
                        </div>
                    )}
                    <div className="d-flex gap-3 align-items-center flex-wrap">
                        
                        {getDifficultyBadge(course.difficulty)}
                        <small className="text-muted">👨‍🏫 {course.instructor_name}</small>
                        {course.estimated_hours && <small className="text-muted">⏱️ {course.estimated_hours} godz.</small>}
                        {course.tags?.length > 0 && (
                            <div className="d-flex gap-1 flex-wrap">
                                {course.tags.map(tag => <Badge key={tag} bg="secondary">{tag}</Badge>)}
                            </div>
                        )}
                    </div>
                </Card.Body>
            </Card>

            {/* Sekcje i lekcje */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Zawartość kursu</h3>
                {isInstructor && isOwner && (
                    <Button variant="outline-primary" size="sm" onClick={() => openSectionModal()}>
                        + Dodaj sekcję
                    </Button>
                )}
            </div>

            {course.sections?.length > 0 ? (
                course.sections.map((section) => (
                    <Card key={section.id} className="mb-3">
                        <Card.Header className="bg-light d-flex justify-content-between align-items-center">
                            <strong>{section.title}</strong>
                            {isInstructor && isOwner && (
                                <div>
                                    <Button variant="outline-primary" size="sm" className="me-2" onClick={() => openSectionModal(section)}>
                                        ✏️
                                    </Button>
                                    <Button variant="outline-danger" size="sm" onClick={() => handleDeleteSection(section.id)}>
                                        🗑️
                                    </Button>

                                </div>
                            )}
                        </Card.Header>
                        <ListGroup variant="flush">
                            {section.lessons?.map((lesson) => (
                                <ListGroup.Item 
                                    key={lesson.id}
                                    className="lesson-item d-flex align-items-center"
                                    style={{ 
                                        cursor: 'pointer',
                                        transition: 'background-color 0.2s ease',
                                        borderRadius: '8px',
                                        padding: '12px 16px'
                                    }}
                                    onClick={() => navigate(`/courses/${id}/lessons/${lesson.id}`)}>
                                    <div className="d-flex align-items-center">
                                        <span className="me-2">
                                            {lesson.content_type === 'video' ? '🎥' : 
                                            lesson.content_type === 'quiz' ? '📝' : 
                                            lesson.content_type === 'assignment' ? '📋' : '📖'}
                                        </span>
                                        <div>
                                            <div className="fw-medium">{lesson.title}</div>
                                            {lesson.duration_minutes && (
                                                <small className="text-muted">{lesson.duration_minutes} min</small>
                                            )}
                                        </div>
                                    </div>
                                    <div 
                                        className="d-flex gap-2 align-items-center ms-auto"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {lesson.content_type === 'quiz' && isInstructor && isOwner && (
                                            <Button 
                                                variant="warning" 
                                                size="sm"
                                                onClick={() => navigate(`/courses/${id}/lessons/${lesson.id}/quiz/edit`)}
                                            >
                                                📝 Edytuj quiz
                                            </Button>
                                        )}
                                        
                                        {isInstructor && isOwner && lesson.content_type !== 'quiz' && (
                                            <>
                                                <Button 
                                                    variant="outline-primary" 
                                                    size="sm"
                                                    onClick={() => navigate(`/courses/${id}/lessons/${lesson.id}/edit`)}
                                                >
                                                    ✏️
                                                </Button>
                                                <Button 
                                                    variant="outline-danger" 
                                                    size="sm"
                                                    onClick={async () => {
                                                        if (window.confirm(`Usunąć lekcję "${lesson.title}"?`)) {
                                                            try {
                                                                await api.delete(`/lessons/${lesson.id}/`);
                                                                fetchCourse();
                                                                setSuccess('Lekcja usunięta!');
                                                            } catch (err) {
                                                                setError('Nie udało się usunąć lekcji');
                                                            }
                                                        }
                                                    }}
                                                >
                                                    🗑️
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </ListGroup.Item>
                            ))}
                            {isInstructor && (
                                <Button 
                                
                                    variant="outline-primary" 
                                    size="sm" 
                                    onClick={() => navigate(`/courses/${id}/sections/${section.id}/lessons/create`)}>
                                    + Dodaj lekcję
                                </Button>
                            )}
                        </ListGroup>
                    </Card>
                ))
            ) : (
                <Alert variant="info">
                    Ten kurs nie ma jeszcze dodanych lekcji.
                    {isInstructor && " Kliknij 'Dodaj sekcję' aby rozpocząć."}
                </Alert>
            )}

            {/* Modal dla sekcji */}
            <Modal show={showSectionModal} onHide={() => setShowSectionModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingSection ? 'Edytuj sekcję' : 'Dodaj sekcję'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Tytuł sekcji</Form.Label>
                            <Form.Control
                                type="text"
                                value={sectionForm.title}
                                onChange={(e) => setSectionForm({ ...sectionForm, title: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Kolejność</Form.Label>
                            <Form.Control
                                type="number"
                                value={sectionForm.order}
                                onChange={(e) => setSectionForm({ ...sectionForm, order: parseInt(e.target.value) })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowSectionModal(false)}>Anuluj</Button>
                    <Button variant="primary" onClick={editingSection ? () => handleEditSection(editingSection) : handleAddSection}>
                        {editingSection ? 'Zapisz' : 'Dodaj'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal dla lekcji */}
            <Modal show={showLessonModal} onHide={() => setShowLessonModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{editingLesson ? 'Edytuj lekcję' : 'Dodaj lekcję'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Tytuł lekcji</Form.Label>
                            <Form.Control
                                type="text"
                                value={lessonForm.title}
                                onChange={(e) => setLessonForm({ ...lessonForm, title: e.target.value })}
                            />
                        </Form.Group>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Typ lekcji</Form.Label>
                                    <Form.Select
                                        value={lessonForm.content_type}
                                        onChange={(e) => setLessonForm({ ...lessonForm, content_type: e.target.value })}
                                    >
                                        <option value="text">Tekst</option>
                                        <option value="video">Wideo</option>
                                        <option value="quiz">Quiz</option>
                                        <option value="assignment">Zadanie</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Czas trwania (minuty)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={lessonForm.duration_minutes}
                                        onChange={(e) => setLessonForm({ ...lessonForm, duration_minutes: parseInt(e.target.value) })}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label>Treść (JSON)</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={JSON.stringify(lessonForm.content, null, 2)}
                                onChange={(e) => {
                                    try {
                                        setLessonForm({ ...lessonForm, content: JSON.parse(e.target.value) });
                                    } catch (err) {
                                        // Błąd parsowania JSON
                                    }
                                }}
                            />
                            <Form.Text className="text-muted">
                                Dla tekstu: {"{\"body\": \"treść...\"}"}<br/>
                                Dla wideo: {"{\"url\": \"https://...\", \"duration\": 300}"}
                            </Form.Text>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowLessonModal(false)}>Anuluj</Button>
                    <Button variant="primary" onClick={editingLesson ? () => handleEditLesson(editingLesson) : handleAddLesson}>
                        {editingLesson ? 'Zapisz' : 'Dodaj'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default CourseDetail;